// src/surveys/analyzers.js

const analyzers = {
  adhd: (answers) => {
    const sometimesPlusItems = [1, 2, 3, 9, 12, 16, 18];
    const partAItems = [1, 2, 3, 4, 5, 6];
    const partBItems = Array.from({ length: 12 }, (_, i) => i + 7); // 7-18

    const verbalItems = [15, 16, 17, 18];
    const motorItems = [5, 6, 12, 13, 14];
    const inattentiveItems = [1, 2, 3, 4, 7, 8, 9, 10, 11];

    let scoredAnswers = {};

    Object.keys(answers).forEach((order) => {
      const val = parseInt(answers[order]);
      const isSometimesPlus = sometimesPlusItems.includes(parseInt(order));

      if (isSometimesPlus) {
        scoredAnswers[order] = val >= 3 ? 1 : 0; // 3, 4, 5
      } else {
        scoredAnswers[order] = val >= 4 ? 1 : 0; // 4, 5
      }
    });

    const sumSubset = (keys) => keys.reduce((acc, k) => acc + (scoredAnswers[k] || 0), 0);

    const partAScore = sumSubset(partAItems);
    const partBScore = sumSubset(partBItems);

    const isSuggestive = partAScore >= 4;

    const subscales = {
      inattentive: sumSubset(inattentiveItems),
      motor: sumSubset(motorItems),
      verbal: sumSubset(verbalItems),
    };

    const resultKeys = [];

    if (isSuggestive) {
      resultKeys.push({ key: 'suggestive' });
      resultKeys.push({ key: 'part_a_high', params: { score: partAScore } });
    } else {
      resultKeys.push({ key: 'not_suggestive' });
      resultKeys.push({ key: 'part_a_low', params: { score: partAScore } });
    }

    if (partBScore > 0) {
      resultKeys.push({ key: 'part_b_info', params: { score: partBScore } });
    }

    // Add Subscales string
    resultKeys.push({
      key: 'subscales',
      params: {
        inattentive: subscales.inattentive,
        motor: subscales.motor,
        verbal: subscales.verbal
      }
    });

    resultKeys.push({ key: 'clinical_note' });

    return {
      totalScore: partAScore + partBScore,
      resultKeys,
      details: { partAScore, partBScore, subscales }
    };
  },

  anxiety: (answers) => {
    const totalScore = Object.values(answers).reduce((acc, val) => acc + parseInt(val), 0);
    let statusKey = "mild";
    if (totalScore >= 18 && totalScore <= 24) statusKey = "mild_moderate";
    if (totalScore >= 25 && totalScore <= 30) statusKey = "moderate_severe";
    if (totalScore > 30) statusKey = "severe";

    return {
      totalScore,
      resultKeys: [{ key: statusKey }]
    };
  }
};

export default analyzers;